const apiConfig = {
    // golangApi: 'http://localhost:8085',
    golangApi: 'https://gocloud.vocabulary.az',
};

export default apiConfig;